module.exports = __webpack_public_path__ + "media/assets/images/flags/as-6e57e395ddb475d15c32eab0e179dec6.svg";